
import config from '../config/config.json';

const host = config.production.hostBackoffice;

/* URL LOGO */
export const urlLogo = host + "/logowebapp.png";